// src/utils/errorMessages.js

/**
 * Traduction des messages d'erreur Supabase en français
 */
export const translateAuthError = (error) => {
  if (!error) return 'Une erreur est survenue';
  
  let errorMessage = '';
  
  if (typeof error === 'string') {
    errorMessage = error;
  } else if (error.message) {
    errorMessage = error.message;
  } else if (error.error_description) {
    errorMessage = error.error_description;
  } else {
    errorMessage = JSON.stringify(error);
  }
  
  const errorLower = errorMessage.toLowerCase();
  
  const errorMap = {
    // Erreurs de connexion
    'invalid login credentials': 'Email ou mot de passe incorrect',
    'email not confirmed': 'Veuillez confirmer votre email avant de vous connecter',
    'invalid email': 'Adresse email invalide',
    
    // Erreurs d'inscription
    'user already registered': 'Un compte existe déjà avec cet email',
    'already registered': 'Un compte existe déjà avec cet email',
    'email already in use': 'Un compte existe déjà avec cet email',
    'password should be at least 6 characters': 'Le mot de passe doit contenir au moins 6 caractères',
    'signup disabled': 'Les inscriptions sont temporairement désactivées',
    
    // Erreurs de validation
    'invalid email format': 'Format d\'email invalide',
    'weak password': 'Mot de passe trop faible',
    
    // Erreurs de session
    'session expired': 'Votre session a expiré, veuillez vous reconnecter',
    'not authenticated': 'Vous devez être connecté pour effectuer cette action',
    'jwt expired': 'Votre session a expiré, veuillez vous reconnecter',
    'invalid jwt': 'Session invalide, veuillez vous reconnecter',
    
    // Erreurs réseau
    'network error': 'Erreur de connexion. Vérifiez votre connexion internet.',
    'failed to fetch': 'Impossible de se connecter au serveur',
    
    // Erreurs de réinitialisation mot de passe
    'user not found': 'Aucun compte trouvé avec cet email',
    'password reset failed': 'La réinitialisation du mot de passe a échoué',
    'new password should be different from the old password': 'Le nouveau mot de passe doit être différent de l\'ancien',
    'same password': 'Le nouveau mot de passe doit être différent de l\'ancien',
    'password is too short': 'Le mot de passe doit contenir au moins 6 caractères',
    'password is too long': 'Le mot de passe est trop long',
    'token has expired': 'Le lien de réinitialisation a expiré, veuillez en demander un nouveau',
    'token not found': 'Lien de réinitialisation invalide ou déjà utilisé',
    'invalid token': 'Lien de réinitialisation invalide ou déjà utilisé',
    'otp expired': 'Le lien de réinitialisation a expiré, veuillez en demander un nouveau',
    
    // Erreurs générales
    'server error': 'Erreur serveur. Veuillez réessayer plus tard.',
    'too many requests': 'Trop de tentatives. Veuillez patienter quelques minutes.',
    'rate limit': 'Trop de tentatives. Veuillez patienter quelques minutes.',
    'email rate limit exceeded': 'Trop d\'emails envoyés. Veuillez patienter quelques minutes.',
    'unable to validate email address': 'Impossible de valider cette adresse email',
    'email link is invalid or has expired': 'Le lien email est invalide ou a expiré',
    'email not found': 'Aucun compte trouvé avec cet email',
  };
  
  for (const [englishError, frenchError] of Object.entries(errorMap)) {
    if (errorLower.includes(englishError)) {
      return frenchError;
    }
  }
  
  console.warn('Erreur non traduite:', error);
  return `Une erreur est survenue : ${errorMessage}`;
};

/**
 * Traduction des messages de succès
 */
export const translateSuccessMessage = (message) => {
  if (!message) return '';
  
  const successMap = {
    'confirmation email sent': 'Email de confirmation envoyé',
    'password updated': 'Mot de passe mis à jour avec succès',
    'email updated': 'Email mis à jour avec succès',
    'user created': 'Compte créé avec succès',
    'recovery email sent': 'Email de réinitialisation envoyé',
    'email confirmed': 'Email confirmé avec succès',
  };
  
  const messageLower = message.toLowerCase();
  
  for (const [english, french] of Object.entries(successMap)) {
    if (messageLower.includes(english)) {
      return french;
    }
  }
  
  return message;
};